// Disguise cover picker: given a candidate cover site URL, returns { title, icon, framable }.
// The backend fetches the target ONLY through its egress proxy (never the backend's own IP), so
// pointing the picker at a hostile URL can't deanonymize the server. See backend SiteMetadata.
export async function probe({ url }) {
  // `silent`: a bad/unreachable cover URL is expected here — don't let the gateway's default
  // error handler navigate the user off the picker; the screen handles the rejection inline.
  return this.post('/site_metadata', { url }, {}, { silent: true });
}
